exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bank[data-v-4f5f0408] {\n  margin-top: 20px !important;\n}\n[data-v-4f5f0408] .el-form-item__label {\n  font-family: Arial, Helvetica, sans-serif;\n}\n[data-v-4f5f0408] .el-dialog__body {\n  padding-bottom: 5px;\n}\n[data-v-4f5f0408] .el-tabs__nav {\n  background: #a0a19ce0;\n}\n[data-v-4f5f0408] .el-tabs__item {\n  color: white;\n}\n[data-v-4f5f0408] .el-tabs__item.is-active {\n  color: white;\n  background: #78a5e7;\n}\n[data-v-4f5f0408] .el-tabs__nav-scroll {\n  float: right;\n}\n[data-v-4f5f0408] .el-tabs__header {\n  margin-bottom: 0;\n}\n", ""]);

// exports
